import { Event } from './event';
import {Site} from '../site';
import {Contact} from '@rbaip/address-form';

export  enum AuctionEventSchedulingStatus {
  Proposed = 'Proposed',
  Confirmed = 'Confirmed',
  Cancelled = 'Cancelled',
  Published = 'Published',
  RolledForward = 'RolledForward'
}

export class AuctionEvent {
  auctionEventId: number;
  eventGuid: string;
  siteId: number;
  saleNumber: string;
  eventName: string;
  event: Event;
  selected = false;
  localEventStartDateTime: number;
  localEventEndDateTime: number;
  isPreSale: boolean;
  isActive: boolean;
  isPostSale: boolean;
  status: string;
  schedulingStatus: AuctionEventSchedulingStatus;
  siteDto: Site;
  siteName: string;
  siteLocation: string;
  allowsIpInspection: boolean;
  displayName: string;
  activeAuction: boolean;
  eventEndedMoreThan30DaysAgo: boolean;
  eventEndedMoreThan120DaysAgo: boolean;
  displayStartDate: string;
  displayEndDate: string;
  eventLocationContactDto: Contact;
  locationType : string;
}

